import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames/bind';

import styles from './Typography.module.scss';

const cx = classNames.bind(styles);

const H3: FC<HTMLAttributes<HTMLElement>> = ({
  children,
  className,
  ...props
}) => {
  const classes = cx('h3', className);

  return (
    <h3 className={classes} {...props}>
      {children}
    </h3>
  );
};

export default H3;
